import { render, staticRenderFns } from "./MailIcon.vue?vue&type=template&id=4019283f&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4019283f')) {
      api.createRecord('4019283f', component.options)
    } else {
      api.reload('4019283f', component.options)
    }
    module.hot.accept("./MailIcon.vue?vue&type=template&id=4019283f&", function () {
      api.rerender('4019283f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/MailIcon.vue"
export default component.exports